import styled from 'styled-components';
import firstBackgroundCareer from '../../assets/background-career-1.svg';
import secondBackgroundCareer from '../../assets/background-career-2.svg';
import Title from '../../components/Typography/Title';
import { Flex } from '../../utilities/GlobalStyle';
import { devices } from '../../utilities/responsive';

interface CondivisionGridItemTextProps {
    textAlign: string; 
    position: string; 
    left: string; 
    top: string;
    bottom: string;
    right: string;
}

export const FirstBackground = styled.div`
    width: 100vw;
    height: 7%;
    position: absolute;
    top: -30px;
    background-image: url(${firstBackgroundCareer});
    background-size: 200vw 100vw;
    background-position: 41% 100%;
    background-repeat: no-repeat;
    @media ${devices.phoneLg} {
        display: none;
    }
`;

export const SecondBackground = styled.div`
    width: 100vw;
    height: 100%;
    position: absolute;
    top: -37%;
    background-image: url(${secondBackgroundCareer});
    background-size: 100vw 120vw;
    background-position: bottom;
    background-repeat: no-repeat;
    @media ${devices.desktopLg} {
        top: -40%;
    }

    @media ${devices.phoneLg} {
        display: none;
    }
`;

export const CareersWrapper = styled.div`
    width: 100%;
    padding: 0 140px;
    
    section {
        h1 {
            font-weight: 700;
        }
    }

    @media ${devices.tabletLandscape} {
        padding: 0 64px;
    }

    @media ${devices.tabletPortrait} {
        padding: 0 16px;
    }
`;

export const WelcomeText = styled.div`
    p {
        font-weight: 700;
    }
`;

export const CareersTitle = styled(Title)`
    color: var(--primary) !important;
    background: red;
`;

export const CondivisionGrid = styled.section`
    margin: 64px 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;

    @media ${devices.tabletPortrait}  {
        margin: 8em 0 !important;
    }

    @media ${devices.phoneLg}  {
        margin: 6em 0 !important;
        grid-template-columns: 1fr;
        padding: 0 !important;
    }
`;

export const CondivisionGridItem = styled.div<{ padding?: number[]; }>`
    position: relative;
    padding: ${({ padding }) => padding && padding.map(p => `${p}px`).join(' ')};

    @media ${devices.tabletPortrait}  {
        padding: 0;
    }

    @media ${devices.phone}  {
        &:nth-of-type(2),
        &:nth-of-type(4) {
            display: none;
        }
    }
`;

export const CondivisionGridItemText = styled.div<Partial<CondivisionGridItemTextProps>>`
    top: ${({ top }) => top && `${top}px`};
    left: ${({ left }) => left && `${left}px`};
    right: ${({ right }) => right && `${right}px`};
    bottom: ${({ bottom }) => bottom && `${bottom}px`};
    text-align: ${({ textAlign }) => textAlign && textAlign};

    &:nth-of-type(1) {
        margin-top: 40px;

        @media ${devices.desktopLg} {
            margin-top: 148px;
        }

        @media ${devices.phoneLg} {
            margin-top: 0;
        }
    }

    @media ${devices.tabletPortrait}  {
        bottom: 0;
    }

    @media ${devices.phoneLg}  {
        position: relative;
        text-align: left;
    }

    h1 {
        margin-bottom: 16px;
    }

    p {
        span {
            font-weight: 700;
        }
    }
`;

export const CondivisionGridItemImage = styled.div<{ h?: string; margin?: number[]; }>`
    width: 100%;
    height: 100%;
    margin: ${({ margin }) => margin && margin.map(m => `${m}px`).join(' ')};

    @media ${devices.tabletPortrait}  {
        margin: 0;
        padding: 0 !important;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const Offer = styled.section`
    margin: 320px 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 64px;

    @media ${devices.tabletPortrait}  {
        margin: 120px 0 !important;
    }
`;

export const OfferWrapper = styled(Flex)`
    align-items: center;
    
    @media ${devices.tabletPortrait} {
        flex-direction: column;
    }
`;

export const OfferWrapperText = styled.div`
    flex: 1;
    margin-left: 24px;

    @media ${devices.tabletPortrait} {
        margin-left: 0;
    }

    // h1 {
    //     color: var(--primary-on-hover) !important;
    // }

    p {
        font-weight: 300;
        margin-top: 16px;
    }
`;

export const ImageWrapper = styled.div<{ w?: string; h?: string; }>`
    position: relative;
    width: ${({ w }) => w ? w : 'auto'};
    height: ${({ h }) => h ? h : 'auto'};

    img {
        position: relative;
        z-index: 1;
    }
`;

export const ImageWrapperPseudoClass = styled(ImageWrapper)`
    flex: 1;

    @media ${devices.tabletPortrait}  {
        margin-bottom: 32px;
        margin-right: 0;
    }
    
    &::after {
        content: '';
        width: 90%;
        height: 130%;
        position: absolute;
        top: -64px;
        left: -64px;
        background: var(--primary-on-hover);

        @media ${devices.tabletPortrait}  {
            height: 95%;
            top: -24px;
        }
    }
`;

export const Candidature = styled.section`
    width: 100%;

    @media ${devices.phone}  {
        height: 100%;
    }

    .send-candidature {
        margin-top: -36px;
        display: flex;
        align-items: center;
        padding: 24px 48px;
        max-width: 400px;
        background: linear-gradient(to right, #654AD2 0%, #2173CF 40%, #247CCC 49%, #36B1BD 100%);
        color: var(--white) !important;
        z-index: 1;
        border-radius: 4px;
        transition: all .3s ease;

        &:hover {
            background: var(--primary-on-hover);
        }

        @media ${devices.phone}  {
            padding: 24px 32px;
            margin-top: -24px;
        }

        @media ${devices.phoneSm} {
            margin-top: 16px;
            padding: 16px;
            font-size: 16px;
            width: 100%;
            justify-content: center;
        }

        svg {
            fill: var(--white);
            width: 24px;
            height: 24px;
            margin-right: 16px;
        }
    }
`;

export const ImageOverlayBox = styled(Flex)`
    width: calc(100% - 10vw);
    padding: 42px 64px 64px;
    border-radius: 6px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .15);
    margin-top: -96px;
    background: white;
    text-align: center;
    z-index: 1;

    @media ${devices.phone}  {
        padding: 24px;
        box-shadow: none;
    }

    @media ${devices.phoneSm} {
        padding: 16px 0;
        background: transparent;
        margin-top: 0;
        text-align: left;

        && {
            h1 {
                color: var(--primary) !important
            }

            p {
                color: black !important;
            }
    
            p { 
                span {
                    font-weight: bold;
                    color: black !important;
                }
            }
        }
    }
 
    p {
        color: black !important;
    }

    p {
        font-weight: 300;

        span {
            color: black !important;
            font-weight: 700;
        }
    }

    h1 {
        margin-bottom: 16px;
    }
`;

export const ImageOverlayBoxContent = styled.div`
    max-width: 80%;

    @media ${devices.tabletPortrait}  {
        max-width: 100%;
    }
`;

export const OurWork = styled.section`
    text-align: center;
    margin: 160px 0 !important;

    h1 {
        margin-bottom: 16px;
    }
`;